export class EditorialPushSection extends HTMLElement {
    connectedCallback() {
      this.infosVideos       = this.querySelectorAll('.editorial-push-section__video');

      this._initVideos();

    }

    /**
     * INIT VIDEO FROM IFRAME
     */
    _initVideos() {
      this.infosVideos.forEach(function(value, index) {
        value.setAttribute('src', value.getAttribute('data-src'));
      });
    }
  
}
try {
  window.customElements.define('editorial-push-section', EditorialPushSection);
} catch(e) {}